import { CalendarPlus, ClipboardCheck, FileCheck2 } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: CalendarPlus,
    title: "Book Appointment",
    desc: "Pick your preferred slot via the form on this page or send a WhatsApp message — we confirm quickly.",
  },
  {
    n: "02",
    icon: ClipboardCheck,
    title: "Visit & Scan",
    desc: "Arrive 10 minutes early. Our team guides you through the scan in a calm, comfortable room.",
  },
  {
    n: "03",
    icon: FileCheck2,
    title: "Receive Reports Quickly",
    desc: "Most reports are ready the same day, shared digitally and in print — clear and clinically detailed.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="py-20 lg:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-[#0099CC]">
            How It Works
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
            Three Simple Steps from <span className="text-[#0099CC]">Booking to Reports</span>
          </h2>
          <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">
            No long queues, no confusion. We’ve designed the entire journey to be calm, quick and transparent.
          </p>
        </div>

        <div className="mt-14 relative">
          <div className="hidden lg:block absolute top-12 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#00BFFF]/40 to-transparent" />
          <ol className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 relative">
            {STEPS.map((s) => (
              <li
                key={s.n}
                data-testid={`step-${s.n}`}
                className="relative bg-[#f8fafc] rounded-2xl p-7 border border-slate-100 hover:bg-white hover:shadow-[0_18px_40px_rgba(15,23,42,0.07)] transition-all duration-300"
              >
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 rounded-2xl bg-white border border-[#00BFFF]/20 text-[#0099CC] flex items-center justify-center shadow-sm">
                    <s.icon className="w-6 h-6" strokeWidth={2.2} />
                  </div>
                  <span className="font-display text-3xl font-bold text-[#00BFFF]/30">{s.n}</span>
                </div>
                <h3 className="mt-5 text-xl font-semibold text-slate-900">{s.title}</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.desc}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
